module.exports = require("@mui/icons-material/Numbers");